import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AppContext } from '@prisjakt/ui-app-context';
import Button from '@prisjakt/ui-button';
import Modal from './index';
import actions from './actions';

import * as S from './confirm.styles';

const ConfirmModal = ({ onCancel, onConfirm, hideModal, ...props }) => {
  const { t } = useContext(AppContext);
  return (
    <Modal
      id={props.id}
      isOpen={props.isOpen}
      width={props.width}
      onRequestClose={() => (onCancel === undefined ? hideModal() : onCancel())}
    >
      <S.Content>
        {props.title && (
          <S.Title>
            <h2>{props.title}</h2>
          </S.Title>
        )}
        <S.Body>{props.children}</S.Body>
        <S.Footer>
          {props.showCancel && (
            <Button
              color="primary"
              variant="outlined"
              onClick={() =>
                onCancel === undefined ? hideModal() : onCancel()
              }
            >
              {props.cancelLabel || t('common', 'button.cancel')}
            </Button>
          )}
          <Button
            color="positive"
            onClick={() =>
              onConfirm === undefined ? hideModal() : onConfirm()
            }
          >
            {props.confirmLabel || t('common', 'button.ok')}
          </Button>
        </S.Footer>
      </S.Content>
    </Modal>
  );
};

const { func, string, bool, node, number } = PropTypes;

ConfirmModal.propTypes = {
  hideModal: func.isRequired,
  onConfirm: func,
  onCancel: func,
  children: node,
  width: number,
  id: string,
  isOpen: bool,
  title: string,
  showCancel: bool,
  confirmLabel: string,
  cancelLabel: string,
};

ConfirmModal.defaultProps = {
  onConfirm: undefined,
  onCancel: undefined,
  children: null,
  width: 400,
  id: undefined,
  isOpen: false,
  title: undefined,
  showCancel: false,
  confirmLabel: undefined,
  cancelLabel: undefined,
};

export default connect(null, actions)(memo(ConfirmModal));
